import React from 'react';
import { Outlet, Navigate } from 'react-router';
import { isEmployeeSignedIn } from '../utils/helper';

const EmployeeProtectedRoutes = () => {
  return isEmployeeSignedIn() ? <Outlet /> : <Navigate to="/employee-login" />;
};

export default EmployeeProtectedRoutes;
